import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"

import DialogHeader from "../../components/DialogHeader"
import { WORKFLOW_STATUS } from "../utils"
import { useUpdateWorkflowStatus } from "./utils"

export default function StopWorkflowDialog({ open, onClose, workflow }) {
  const { isUpdatingStatus, updateStatus } = useUpdateWorkflowStatus()

  function handleStopButtonClicked() {
    updateStatus(workflow, WORKFLOW_STATUS.stopped, onClose)
  }

  function handleSoftClose() {
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogHeader title="Deactivate Workflow" onClose={handleSoftClose} />
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Are you sure you want to stop this workflow? This will do the
          following:
        </Typography>
        <ol>
          <Typography component="li">
            No new candidates will be enrolled into this workflow.
          </Typography>
          <Typography component="li">
            Existing candidates will not progress to the next step in the
            workflow.
          </Typography>
        </ol>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleSoftClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="error"
          loading={isUpdatingStatus}
          onClick={handleStopButtonClicked}
        >
          Stop
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
